import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import { CreateMeetingFormData } from "./types";
import {
  CreateMeetingForm,
  isCreateMeetingFormValid,
  getDefaultCreateMeetingFormData,
  prepareCreateMeetingSubmitData,
} from "./CreateMeetingForm";

interface CreateMeetingDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (formData: CreateMeetingFormData) => void;
}

export const CreateMeetingDialog: React.FC<CreateMeetingDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const [formData, setFormData] = React.useState<CreateMeetingFormData>(
    getDefaultCreateMeetingFormData()
  );
  const [enableMaxDuration, setEnableMaxDuration] = React.useState(false);

  const handleSubmit = () => {
    const submitData = prepareCreateMeetingSubmitData(formData, enableMaxDuration);
    onSubmit(submitData);
    resetForm();
  };

  const resetForm = () => {
    setFormData(getDefaultCreateMeetingFormData());
    setEnableMaxDuration(false);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Create New Meeting</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <CreateMeetingForm
            formData={formData}
            onChange={setFormData}
            enableMaxDuration={enableMaxDuration}
            onEnableMaxDurationChange={setEnableMaxDuration}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!isCreateMeetingFormValid(formData)}
          sx={{
            backgroundColor: "#7357FF",
            "&:hover": { backgroundColor: "#5a42cc" },
          }}
        >
          Create Meeting
        </Button>
      </DialogActions>
    </Dialog>
  );
};
